// extracted by mini-css-extract-plugin
export var container = "_g7-0";
export var content = "_g7-3";
export var customerTitle = "_g7-4";
export var empty = "_g7-5";
export var gray = "_g7-6";
export var header = "_g7-7";
export var info = "_g7-8";
export var loading = "_g7-2";
export var loadingCard = "_g7-9";
export var oneLine = "_g7-a";
export var personName = "_g7-e";
export var pillContainer = "_g7-b";
export var selected = "_g7-1";
export var text = "_g7-c";
export var twoLines = "_g7-d";
export var unread = "_g7-f";
export var unreadIndicator = "_g7-g";